import { VehicleQuestionsService } from '../../../vehicle-questions.service';
import { EventEmitter, Injectable } from '@angular/core';
import { Dictionary } from '../../../../configuration/dictionary';
import { VehicleDataEnum } from '../../../../consts/vehicle-data.enum';
import { CalculationService } from '../../calculation.service';
import { ConfigurationService } from '../../configuration/configuration.service';
import { CalculationStorageService } from '../../../../../shared/services/calculation-storage.service';
import { VehicleDataModel } from '../../../../models/vehicle-data.model';
import { VehicleDataInterface } from '../../../api/sections-api/vehicle-data.interface';
import { VehicleModelStateService } from '../vehicle-model/vehicle-model-state.service';
import { VehicleCondition } from '../../../../consts/vehicle-condition.enum';
import { Dictionaries, UiConfig } from '../../../../configuration/ui-config';
import * as moment from 'moment';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { VehicleStateModel } from '../../../../models/vehicle-state.model';
import {endOfYear, today} from '../../../../../shared/utils/time-utils';

@Injectable({
  providedIn: 'root'
})
export class VehicleDataStateService implements VehicleDataInterface {

  public vehicleCondition = VehicleCondition;
  private dictionaries: Dictionaries;

  constructor(private logicService: CalculationService,
              private storage: CalculationStorageService,
              private configuration: ConfigurationService,
              private vehicleModelService: VehicleModelStateService,
              private vehicleQuestionsService: VehicleQuestionsService) {
    this.dictionaries = this.configuration.uiConfig.dictionaries;
  }

  get vehicleData(): VehicleDataModel {
    return this.logicService.vehicleData;
  }

  get vehicleState(): VehicleStateModel {
    return this.logicService.vehicleState;
  }

  get abroadUsageTimeDictionary(): Dictionary {
    if (this.dictionaries) {
      return this.dictionaries[UiConfig.ABROAD_USAGE_TIME];
    }
    return null;
  }

  get countryOfOriginDictionary(): Dictionary {
    if (this.dictionaries) {
      return this.dictionaries[UiConfig.VEHICLE_COUNTRY_OF_ORIGIN];
    }
    return null;
  }

  get partyTypeCodeDictionary(): Dictionary {
    if (this.dictionaries) {
      return this.dictionaries[UiConfig.PARTY_TYPE_CODE];
    }
    return null;
  }

  get isValidCarInspectionInspectionDictionary(): Dictionary {
    if (this.dictionaries) {
      return this.dictionaries[UiConfig.IS_VALID_CAR_INSPECTION];
    }
    return null;
  }

  get vehicleTypeDictionary(): Dictionary {
    if (this.dictionaries) {
      return this.dictionaries[UiConfig.VEHICLE_TYPE];
    }
    return null;
  }

  getProductionDate(): number {
    return this.vehicleModelService.vehicleData.productionYear;
  }

  getMaxFirstRegistrationDate(): string {
    if (isNotNullOrUndefined(this.getProductionDate())) {
      const maxDate = endOfYear(this.getProductionDate() + 3);
      const currentDate = today();
      return moment(maxDate).isBefore(currentDate) ? maxDate : currentDate;
    }
    return today();
  }

  productionDateChange(): EventEmitter<number> {
    return this.vehicleModelService.productionYearChangeEvent;
  }

  changeFirstRegistrationDate(date: Date): void {
    if (isNotNullOrUndefined(date)) {
      const utcDate = moment(date).utc(true).toDate();
      this.vehicleData.firstRegistrationDate = utcDate;
    } else {
      this.vehicleData.firstRegistrationDate = null;
    }
    this.storage.updateCalculation();
  }

  // changeVehicleType(vehicleType: string): void {
  //   this.vehicleData.type = vehicleType;
  //   this.storage.updateCalculation();
  // }

  changeIsLeftHandDrive(isLeftHandDrive: boolean): void {
    this.vehicleQuestionsService.updateQuestion(this.vehicleData, VehicleDataEnum.IS_LEFT_HAND_DRIVE, isLeftHandDrive);
    this.storage.updateCalculation();
  }

  changeIsGasInstallation(isGasInstallation: boolean): void {
    this.vehicleQuestionsService.updateQuestion(this.vehicleData, VehicleDataEnum.IS_GAS_INSTALLATION, isGasInstallation);
    this.storage.updateCalculation();
  }

  changeIsServiceHistory(isServiceHistory: boolean): void {
    // this.updateQuestion(VehicleDataEnum.IS_SERVICE_HISTORY, isServiceHistory);
    this.storage.updateCalculation();
  }
}
